/* istanbul ignore file */
export { default } from './TextInput';
